import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userChatToken: '',
    loadingState: false,
    themeState: false,
    nextNode: [],
    aiStatus: false,
    bubbleStatus: true,
  },
  getters: {
  },
  mutations: {
    SET_USER_CHART_TOKEN(state, payload) {
      state.userChatToken = payload
    },
    SET_LOADING_STATE(state, payload) {
      state.loadingState = payload
    },
    SET_THEME_STATE(state, payload) {
      state.themeState = payload
    },
    SET_ARR(state, payload) {
      state.nextNode = payload
    },
    SET_AI(state, payload) {
      state.aiStatus = payload
    },
    SET_BUBBLE(state, payload) {
      state.bubbleStatus = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
